import Staffings from './Staffings';

export default Staffings;
